import { Link } from "react-router-dom";

const beliefs = [
  ["Useful before impressive", "The system has to move a real task, decision, or conversation forward."],
  ["Human judgement stays visible", "AI gets a role, a boundary, and a clear point where someone should step in."],
  ["Failure is designed too", "Recovery, review, and escalation shape trust just as much as the successful path."],
  ["The business supports the life", "Growth is not progress if every improvement adds another thing to remember."],
];

export function AboutPage() {
  return (
    <main id="main-content" className="interior-world about-world">
      <section className="about-sculpture-hero">
        <div className="about-sculpture-copy">
          <p className="route-kicker" data-hero-support>About Hello Marky</p>
          <h1>
            <span data-hero-line><span>Let systems carry</span></span>
            <span data-hero-line><span>the repeatable work.</span></span>
          </h1>
          <p data-hero-support>We design technology around human judgement, clearer work, and more room to think.</p>
          <a className="world-button" href="#about-principles" data-hero-support>Read our approach</a>
        </div>
        <div className="about-sculpture-stage">
          <img src="/visuals/marky-about-bridge.webp" alt="Marky carrying a bridge between human judgement and connected business tools" width="1536" height="1024" fetchPriority="high" data-route-object />
        </div>
      </section>

      <section className="about-manifesto-world" id="about-principles">
        <p data-reveal>Comfort through capable systems.</p>
        <div data-reveal>
          <h2>The sophistication belongs behind the scenes.</h2>
          <p>The day in front of it should become simpler. That principle guides our product work and every client system we design.</p>
        </div>
      </section>

      <section className="about-human-proof">
        <div className="about-human-media" data-clip-reveal>
          <img src="/portfolio/hello-marky-chat-calm-close.webp" alt="A business owner closing her laptop after customer work is handled" loading="lazy" data-parallax />
        </div>
        <blockquote data-reveal>“The best system gives people their attention back.”</blockquote>
      </section>

      <section className="about-belief-stack">
        <h2 data-reveal>Our standard for good work.</h2>
        <div>
          {beliefs.map(([title, body]) => (
            <article key={title} data-reveal>
              <h3>{title}</h3>
              <p>{body}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="about-product-origin">
        <div className="about-product-mark" data-reveal>
          <img src="/brand/marky-solid.svg" alt="Marky" />
        </div>
        <div data-reveal>
          <h2>We build our own proof.</h2>
          <p>Hello Marky Chat forces customer experience, business rules, AI behavior, permissions, billing, support, and operational pressure into one product.</p>
          <Link className="world-button" to="/work/hello-marky-chat">Read the product story <span aria-hidden="true">↗</span></Link>
        </div>
      </section>

      <section className="interior-close">
        <img src="/brand/marky-dark.svg" alt="" aria-hidden="true" />
        <h2>Bring us the part nobody has had time to untangle.</h2>
        <Link className="world-button" to="/contact">Tell us what feels heavy <span aria-hidden="true">↗</span></Link>
      </section>
    </main>
  );
}
